module.exports = __webpack_public_path__ + "static/img/piggy-bank.5e4620c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/piggy-bank.svg
// module id = DJ58
// module chunks = 1